import {watch} from 'vue';
import type {RouteLocationNormalizedLoaded, RouteLocationRaw, Router} from 'vue-router';

import {UserModel} from '@/entities/User';
import {AUTH_QUERY, REDIRECT_QUERY} from '@/features/AuthForm';
import {screen_breakpoint_md} from '@/shared/lib/utils/platform';

import {routeName as mainRouteName} from './routes/main';
import {routeName as servicesRouteName} from './routes/cabinet/services_mobile';

// Та же граница, что у mobile из useDisplay в кабинете (Vuetify mobileBreakpoint: lg)
const isMobileLayout = () => window.matchMedia(`(max-width: ${screen_breakpoint_md - 0.02}px)`).matches;

/**
 * Куда отправить гостя с закрытой страницы. На мобиле — в «Сервисы»: они открыты гостям
 * и служат мобильным меню. На десктопе пустой кабинет гостю не нужен — на главную.
 */
function getAuthRoute(to: RouteLocationNormalizedLoaded): RouteLocationRaw {
    const query = {[AUTH_QUERY]: '1', [REDIRECT_QUERY]: to.fullPath};
    return {name: isMobileLayout() ? servicesRouteName : mainRouteName, query};
}

/** Не пускает гостя на маршруты с meta.requiresAuth: редирект с окном входа и возвратом после него */
export function installAuthGuard(router: Router): void {
    router.beforeEach((to) => {
        if (to.meta.requiresAuth && !UserModel.isAuth.value) {
            return getAuthRoute(to);
        }
    });

    // Сессия кончилась прямо на закрытой странице (выход, протухший токен) — уводим так же
    watch(UserModel.isAuth, (value) => {
        const current = router.currentRoute.value;
        if (!value && current.meta.requiresAuth) {
            router.replace(getAuthRoute(current));
        }
    });
}
